/** Flat USD pricing — derived from billingCatalog (do not duplicate prices here). */
import {
  BILLABLE_PRODUCT_IDS,
  PRODUCT_BILLING,
  estimateSelectedProductsMonthlyUsd,
  seatQuantityForProduct,
  type ProductBillingDefinition,
} from './billingCatalog';
import type { ProductId } from './products';

export const PLAN_PRICE_USD_PER_SEAT = PRODUCT_BILLING.pm.priceUsd;
export const PLAN_TRIAL_DAYS = 30;

export type WorkspaceBillableProductId = ProductId;

export const WORKSPACE_BILLABLE_PRODUCT_IDS = BILLABLE_PRODUCT_IDS;

export const WORKSPACE_FLAT_PRICING = Object.fromEntries(
  BILLABLE_PRODUCT_IDS.map((id) => {
    const def = PRODUCT_BILLING[id];
    return [id, { priceUsd: def.priceUsd, unit: def.unitLabel, label: def.shortLabel }];
  }),
) as Record<ProductId, { priceUsd: number; unit: string; label: string }>;

export function isWorkspaceBillableProduct(id: string): id is WorkspaceBillableProductId {
  return id in PRODUCT_BILLING;
}

export function estimateWorkspaceMonthlyUsd(
  productIds: WorkspaceBillableProductId[],
  seatsByProduct: Partial<Record<WorkspaceBillableProductId, number>> = {},
): number {
  return estimateSelectedProductsMonthlyUsd(productIds, seatsByProduct);
}

export { PRODUCT_BILLING, estimateSelectedProductsMonthlyUsd, seatQuantityForProduct };
export type { ProductBillingDefinition };
